// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"24b70304","180":"716f4532","361":"d25a25cb","511":"f1731202","669":"2ad03c51","673":"a9d221b9","767":"deb4b1ce","794":"f084c49b","800":"c8e8c4ef","815":"b1c9230c","875":"63d8c6eb"}[chunkId] + ".chunk.js";
};